import React from 'react';

export default () => {
  return <h1 style={{ paddingTop: '200px', textAlign: 'center' }}>404</h1>;
};
